import classNames from 'classnames';
import React, { ForwardedRef } from 'react';

import CloseIcon from '../icons/CloseIcon';
import BasicButton, { BasicButtonProps } from './BasicButton';

import styles from '../../styles/buttons/menu-button.module.css';

interface CloseButtonProps extends BasicButtonProps {
    buttonRef?: ForwardedRef<HTMLButtonElement>;
}

function CloseButton({ className = null, buttonRef = null, ...props }: CloseButtonProps) {
    return (
        <BasicButton
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            ref={buttonRef}
            {...props}
        >
            <CloseIcon className={styles.icon} />
        </BasicButton>
    );
}

export default React.forwardRef<HTMLButtonElement, Omit<CloseButtonProps, 'buttonRef'>>(
    function CloseButtonRef(props, ref) {
        return <CloseButton {...props} buttonRef={ref} />;
    },
);
